<template>
  <router-view></router-view>
</template>

<script>
import * as Cronitor from "@cronitorio/cronitor-rum-js";

export default {
  name: "App",
  mounted() {
    Cronitor.load("30cd529587dc4969c28fc3dca7e7813b");
    Cronitor.track("Pageview");
  },
};
</script>
